import { useCallback, useEffect, useRef, useState } from 'react';
import { Helmet } from 'react-helmet-async';
// @mui
import {
    Box,
    Button,
    Card,
    CircularProgress,
    Container,
    IconButton,
    Stack,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
} from '@mui/material';
// components
import * as XLSX from 'xlsx';
import Iconify from '../components/iconify';
import Label from '../components/label';
// sections
import { UserListToolbar } from '../sections/@dashboard/user';
// mock
import { ButtonGroup } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import AddButton from 'src/components/Button.js/AddBotton';
import ConfirmLockModal from 'src/components/modal/ConfirmLockModal';
import ModalCreateUser from 'src/components/modal/CreateUserModal';
import { glb_sv, sendRequest, serviceList } from 'src/utils';

import { useDownloadExcel } from 'react-export-table-to-excel';
import Breadcrumb from 'src/components/Breadcrumb/Breadcrumb';
import Loader from 'src/components/loader/loader';
import CreateUserExcelModal from 'src/components/modal/CreateUserExcelModal';

import debounce from 'lodash/debounce';
import RegisterCardNoModal from 'src/component-project/RegisterCardNoModal';
import RegisterFaceIDModal from 'src/component-project/RegisterFaceIDModal';
import EmtyData from 'src/components/emty-data';
import InfoUserDetailModal from 'src/components/modal/InfoUserDetailModal';
import crypt from 'src/utils/service/crypt';

// ----------------------------------------------------------------------

export default function Users() {
    const { t } = useTranslation();
    const TABLE_HEAD = [
        // { id: 'info'},
        { id: 'name_staff', label: t('name_staff'), alignRight: false },
        { id: 'username', label: t('username'), alignRight: false },
        { id: 'rfid', label: t('RFID_code'), alignRight: false },
        { id: 'faceID', label: t('FaceID'), alignRight: false },
        { id: 'cardNo', label: t('Card No'), alignRight: false },
        { id: 'Email', label: 'Email', alignRight: false },
        { id: 'phone_supplier', label: t('phone_supplier'), alignRight: false },
        { id: 'department', label: t('department'), alignRight: false },
        { id: 'group_staff', label: t('group_staff'), alignRight: false },
        { id: 'status', label: t('status'), alignRight: false },
        { id: '' },
    ];
    const params = useParams();
    const [visibleDel, setVisibleLock] = useState(false);
    const throttled = useRef(debounce(() => getData(), 1000));

    const tableRef = useRef(null);
    const [getFlags, setGetFlags] = useState(false);
    const isEdit = useRef(false);
    const [tableData, setTableData] = useState([]);
    const lock = useRef(false);
    const [deleleFlags, setLockFlags] = useState(false);

    const [dataAction, setDataAction] = useState({});
    const [checkDataExcel, setCheckDataExcel] = useState(false);

    const [visible, setVisible] = useState(false);
    const [dataExcel, setDataExcel] = useState([]);
    const [visibleExcel, setVisibleExcel] = useState(false);

    const searchValueDeboun = useRef('');
    const arrFillters = useRef([]);
    const fileInputRef = useRef(null);
    const [total, setTotal] = useState(0);

    const getRef = useRef(false);
    const lastID = useRef(0);

    const [visibleFaceID, setVisibleFaceID] = useState(false);
    const [visibleCardNo, setVisibleCardNo] = useState(false);

    const [visibleInfoUserID, setVisibleInfoUserID] = useState(false);
    const [userId, setUserId] = useState();

    const [tableDataExcel, setTableDataExcel] = useState([]);
    const [getFlagsExcel, setGetFlagsExcel] = useState(false);
    const getRefExcel = useRef(false);
    const [needGetDataNext, setNeedGetDataNext] = useState(false);
    const [totalExcel, setTotalExcel] = useState(0);
    const lastIDExcel = useRef(0);

    const [getDetailFlags, setGetDetailFlags] = useState(false);
    const getRefDetail = useRef(false);

    const menu = sessionStorage.getItem('menu');
    let screenPermissions = {};

    if (menu) {
        try {
            const data = JSON.parse(crypt.deCode(menu));
            // console.log('Loading menu', data[0]);
            screenPermissions = data[0].filter((item) => item.screens_key === 'ds_nv')[0];
            // console.log('screenPermissions', screenPermissions);
        } catch (error) {}
    }

    useEffect(() => {
        setTimeout(() => {
            getData();
        }, 1000);
    }, []);

    useEffect(() => {
        setTimeout(() => {
            getDataExcel();
        }, 1500);
    }, []);

    useEffect(() => {
        if (needGetDataNext) {
            getDataNextExcel();
            setNeedGetDataNext(false);
        }
    }, [needGetDataNext]);

    // Lấy dữ liệu danh sách nhân viên dành cho xuất excel
    const getDataExcel = useCallback(() => {
        if (getRefExcel.current) {
            return;
        }
        setGetFlagsExcel(true);
        getRefExcel.current = true;
        const InVal = [9999999999999999999, (searchValueDeboun?.current || '')?.toUpperCase()];
        sendRequest(serviceList.getAllstaff, InVal, getDataResultExcel, true, timeOutFunctExcel, 40000);
    }, []);

    const getDataResultExcel = (reqInfoMap, message) => {
        setGetFlagsExcel(false);
        getRefExcel.current = false;
        if ((message['proc_status']?.toString() || '0') === '0') {
            return;
        } else {
            const data = message.proc_data.rows[0].o_1;
            setTableDataExcel(message.proc_data.rows[0].o_1);
            setTotalExcel(message.proc_data.rowTotal);
            lastIDExcel.current = message.proc_data.rows[0].o_1?.at(-1)?.id;
            if (data.length < message.proc_data.rowTotal) {
                setNeedGetDataNext(true);
            }
        }
    };

    const getDataNextExcel = () => {
        if (getRefExcel.current) {
            return;
        }
        setGetFlagsExcel(true);
        getRefExcel.current = true;
        const InVal = [lastIDExcel.current, (searchValueDeboun?.current || '')?.toUpperCase()];
        sendRequest(serviceList.getAllstaff, InVal, getDataResultNextExcel, true, timeOutFunctExcel, 40000);
    };

    const getDataResultNextExcel = (reqInfoMap, message) => {
        setGetFlagsExcel(false);
        getRefExcel.current = false;
        if ((message['proc_status']?.toString() || '0') === '0') {
            return;
        } else {
            const dataNewExcel = [...message.proc_data.rows[0].o_1, ...tableDataExcel];
            setTableDataExcel([...message.proc_data.rows[0].o_1, ...tableDataExcel]);
            setTotal(message.proc_data.rowTotal);
            if (message.proc_data.rows[0].o_1?.length > 0) {
                lastIDExcel.current = message.proc_data.rows[0].o_1?.at(-1)?.id;
                if (dataNewExcel.length < message.proc_data.rowTotal) {
                    setNeedGetDataNext(true);
                }
            }
        }
    };
    const timeOutFunctExcel = (reqInfo) => {
        getRefExcel.current = false;
        setGetFlagsExcel(false);
    };

    // Hiển thị danh sách nhân viên
    const getData = useCallback(() => {
        if (getRef.current) {
            return;
        }
        setGetFlags(true);
        getRef.current = true;
        const InVal = [9999999999999999999, (searchValueDeboun?.current || '')?.toUpperCase()];
        sendRequest(serviceList.getAllstaff, InVal, getDataResult, true, timeOutFunct, 40000);
    }, []);

    const getDataResult = (reqInfoMap, message) => {
        setGetFlags(false);
        getRef.current = false;
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            setTableData(message.proc_data.rows[0].o_1);
            setTotal(message.proc_data.rowTotal);
            lastID.current = message.proc_data.rows[0].o_1?.at(-1)?.id;
            arrFillters.current = message.proc_data.rows[0].o_1;
            // console.log(lastID.current);
        }
    };
    const getDataNext = () => {
        if (getRef.current) {
            return;
        }
        setGetFlags(true);
        getRef.current = true;
        const InVal = [lastID.current, (searchValueDeboun?.current || '')?.toUpperCase()];
        sendRequest(serviceList.getAllstaff, InVal, getDataResultNext, true, timeOutFunct, 40000);
    };

    const getDataResultNext = (reqInfoMap, message) => {
        setGetFlags(false);
        getRef.current = false;
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            setTableData([...tableData, ...message.proc_data.rows[0].o_1]);
            setTotal(message.proc_data.rowTotal);
            if (message.proc_data.rows[0].o_1?.length > 0) {
                lastID.current = message.proc_data.rows[0].o_1?.at(-1)?.id;

                arrFillters.current = message.proc_data.rows[0].o_1;
            }
        }
    };

    const timeOutFunct = (reqInfo) => {
        getRef.current = false;
        setGetFlags(false);
        // toast.error(t('error.time_out' + 11));
    };

    const handleLock = () => {
        if (!dataAction.id) return toast.error(t('error.system_error'));
        if (lock.current) {
            return;
        }
        setLockFlags(true);
        lock.current = true;
        const InVal = [dataAction.id, dataAction.block === '1' ? '0' : '1'];
        sendRequest(serviceList.lockstaff, InVal, deleteResult, true, timeOutFunctDel, 40000);
    };

    const deleteResult = (reqInfoMap, message) => {
        setLockFlags(false);
        lock.current = false;
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            setVisibleLock(false);
            return;
        } else {
            toast.success(message['proc_message']);
            setVisibleLock(false);
            getByIdUser(dataAction.id);
            // getData();
        }
    };

    const timeOutFunctDel = (reqInfo) => {
        setLockFlags(false);
        lock.current = false;
        toast.error(t('error.time_out'));
    };

    //Lấy thông tin chi tiết của user
    const getByIdUser = (userId) => {
        if (!userId) {
            return;
        }
        if (getRefDetail.current) {
            return;
        }
        getRefDetail.current = true;
        setGetDetailFlags(true);
        const Inval = [userId];
        sendRequest(serviceList.getByIdStaffBase, Inval, getByIdUserResult, true, timeOutFunctGetByIdUser, 40000);
    };

    const getByIdUserResult = (reqInfoMap, message) => {
        getRefDetail.current = false;
        setGetDetailFlags(false);
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            let data = message.proc_data.rows[0].o_1;
            const updatedArray = updateTableData(tableData, data[0]);
            setTableData(updatedArray);
        }
    };

    const timeOutFunctGetByIdUser = (reqInfo) => {
        getRefDetail.current = false;
        setGetDetailFlags(false);
        toast.error(t('error.time_out'));
    };

    // Hàm cập nhật mảng dữ liệu
    const updateTableData = (array, newData) => {
        return array.map((item) => {
            if (item.id === newData.id) {
                return { ...item, ...newData };
            }
            return item;
        });
    };

    const searchValue = (value) => {
        if (!value) {
            value = '';
        }
        searchValueDeboun.current = value;
        // setvalueSearch(value);
        throttled.current();
    };
    const { onDownload } = useDownloadExcel({
        currentTableRef: tableRef.current,
        filename: t('staff_list'),
        sheet: t('staff_list'),
    });

    const handleFileUpload = (event) => {
        setDataExcel([]);
        deleteTableExcel();
        if (event.target.files.length > 0) {
            setCheckDataExcel(true);
            const file = fileInputRef.current.files[0];
            try {
                const reader = new FileReader();

                reader.onload = (e) => {
                    const data = new Uint8Array(e.target.result);
                    const workbook = XLSX.read(data, { type: 'array' });
                    if (workbook.SheetNames.length > 0) {
                        // Lấy dữ liệu từ sheet đầu tiên
                        const worksheet = workbook.Sheets[workbook.SheetNames[0]];
                        const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

                        // console.log(jsonData);
                        if (jsonData?.length > 0) {
                            jsonData.map((user, index) => {
                                if (index !== 0)
                                    if (user.length === 6) {
                                        user[3] = `${user[3]}`;
                                        user[1] = `${user[1]}`;
                                        user[5] = btoa(user[5]);
                                        importExcel(user);
                                    } else {
                                        setTimeout(() => {
                                            toast.error(`${t('row_data')}${index} ${t('invalid')}`);
                                        }, index * 100 + 1000);
                                    }
                                if (index + 1 === jsonData.length) {
                                    // setTotalDataExcel(jsonData.length);
                                    setVisibleExcel(true);
                                }
                            });
                        } else {
                            toast.error(t('data_file_err'));
                        }
                    } else {
                        toast.error(t('file_excel_err'));
                    }
                    // In ra dữ liệu từ file Excel
                };

                reader.readAsArrayBuffer(file);
            } catch (error) {}
            setCheckDataExcel(false);
        } else {
        }
        fileInputRef.current.value = '';
    };

    // Đưa dữ liệu lên server
    const importExcel = (data) => {
        sendRequest(serviceList.importStaff, data, importExcelResult, true, timeOutImport, 40000);
    };
    const importExcelResult = (reqInfoMap, message) => {
        if ((message['proc_status']?.toString() || '0') === '0') {
            return;
        } else {
            const data = message.proc_data.rows;
            const newArr = dataExcel;
            newArr.push(data);
            setDataExcel(JSON.parse(JSON.stringify(newArr)));
        }
    };
    const timeOutImport = (reqInfo) => {};

    const deleteTableExcel = () => {
        const InVal = [];
        sendRequest(serviceList.deleteTabelExcel, InVal, deleteExcelResult, true, timeOutDeleteTabbelExcel, 40000);
    };

    const deleteExcelResult = (reqInfoMap, message) => {
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error(message['proc_message']);
            return;
        }
    };
    const timeOutDeleteTabbelExcel = (reqInfo) => {};

    // Thông tin chi tiết của User và thông tin đăng ký trên thiết bị Hikvision
    const handleClickDetail = (userId) => {
        // console.log("HandleClick", userId);
        setUserId(userId);
        setVisibleInfoUserID(true);
    };

    return (
        <>
            <Helmet>
                <title> {t('staff_list')} </title>
            </Helmet>

            <Container>
                <Loader loading={getFlags} />
                <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1} flexWrap={'wrap'}>
                    <Typography variant="h4" gutterBottom>
                        {t('staff_list')}
                    </Typography>{' '}
                    <Stack direction="row" alignItems="center" justifyContent="space-between" mb={0} gap={1}>
                        <Button
                            variant="contained"
                            startIcon={<Iconify icon="mingcute:file-export-line" />}
                            onClick={onDownload}
                        >
                            {t('export_excel')}
                        </Button>
                        <label htmlFor="import" style={{ cursor: 'pointer' }}>
                            <Button
                                variant="contained"
                                disabled={checkDataExcel}
                                startIcon={<Iconify icon="mingcute:file-import-line" />}
                                // onClick={handleFileUpload}
                            >
                                <label htmlFor="import"> {t('import') + ' excel'}</label>{' '}
                                {checkDataExcel && (
                                    <CircularProgress
                                        size={24}
                                        sx={{
                                            color: 'red',
                                            position: 'absolute',
                                            top: '50%',
                                            left: '50%',
                                            marginTop: '-12px',
                                            marginLeft: '-12px',
                                        }}
                                    />
                                )}
                            </Button>
                        </label>{' '}
                        <input
                            accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                            type="file"
                            hidden
                            ref={fileInputRef}
                            onChange={handleFileUpload}
                            id="import"
                            name="import"
                        />
                        <Button variant="contained" startIcon={<Iconify icon="mingcute:file-download-line" />}>
                            <a
                                style={{ textDecoration: 'none', color: 'white' }}
                                target="_blank"
                                download
                                to={`${glb_sv.urlDownloadFileExcel('dsImportUser.xlsx')}`}
                                href={`${glb_sv.urlDownloadFileExcel('dsImportUser.xlsx')}`}
                            >
                                {t('download_file')}
                            </a>
                        </Button>
                    </Stack>{' '}
                </Stack>{' '}
                <Breadcrumb paths={[{ label: t('staff_list'), url: '#', navigate: false }]} />
                <CreateUserExcelModal
                    visible={visibleExcel}
                    setVisible={setVisibleExcel}
                    setDataExcel={setDataExcel}
                    dataExcel={dataExcel}
                    fuctGet={getData}
                />
                <ModalCreateUser
                    fuctGet={getData}
                    idPermission={params.idPermission}
                    setVisible={setVisible}
                    visible={visible}
                    isEdit={isEdit.current}
                    dataUpdate={dataAction}
                    fuctGetById={getByIdUser}
                />
                <InfoUserDetailModal visible={visibleInfoUserID} setVisible={setVisibleInfoUserID} userId={userId} />
                <Card>
                    <UserListToolbar getValue={searchValue} />
                    <ConfirmLockModal
                        visible={visibleDel}
                        setVisible={setVisibleLock}
                        loading={deleleFlags}
                        handleSave={handleLock}
                    />
                    <RegisterFaceIDModal
                        fuctGet={getData}
                        visible={visibleFaceID}
                        setVisible={setVisibleFaceID}
                        dataUpdate={dataAction}
                    />
                    <RegisterCardNoModal
                        fuctGet={getData}
                        visible={visibleCardNo}
                        setVisible={setVisibleCardNo}
                        dataUpdate={dataAction}
                    />

                    {/* <Scrollbar sx={{ padding: 2 }}> */}
                    <TableContainer sx={{ padding: 1, width: '100%' }}>
                        <Table sx={{ paddingLeft: 2, width: '100%' }}>
                            {/* <UserListHead headLabel={TABLE_HEAD} /> */}
                            <TableHead>
                                <TableRow>
                                    {TABLE_HEAD.map((item, index) => {
                                        return <TableCell key={index}>{item.label}</TableCell>;
                                    })}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {tableData.length > 0 &&
                                    tableData.map((item, index) => {
                                        return (
                                            <TableRow hover key={index} tabIndex={-1} role="checkbox">
                                                <TableCell component="th" scope="row">
                                                    <Typography variant="subtitle2" noWrap>
                                                        {index + 1}. {item.user_nm}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell align="left" width={200} style={{ minWidth: '150px' }}>
                                                    {item.accounts?.toLowerCase()}
                                                </TableCell>
                                                <TableCell align="left" width={200}>
                                                    {item.code_rfid}
                                                </TableCell>
                                                <TableCell align="left">
                                                    {item.face_img_nm ? (
                                                        <img
                                                            src={`${glb_sv.urlGetFaceImage(item.face_img_nm)}`}
                                                            onClick={() => {
                                                                setDataAction(item);
                                                                setVisibleFaceID(true);
                                                            }}
                                                        />
                                                    ) : (
                                                        <IconButton
                                                            size="large"
                                                            color={'dark'}
                                                            onClick={() => {
                                                                setDataAction(item);
                                                                setVisibleFaceID(true);
                                                            }}
                                                        >
                                                            <Iconify icon={'mynaui:face-id'} />
                                                        </IconButton>
                                                    )}
                                                </TableCell>
                                                <TableCell align="left">
                                                    {item.card_no ? (
                                                        <div
                                                            onClick={() => {
                                                                setDataAction(item);
                                                                setVisibleCardNo(true);
                                                            }}
                                                        >
                                                            {item.card_no}
                                                        </div>
                                                    ) : (
                                                        <IconButton
                                                            size="large"
                                                            color={'dark'}
                                                            onClick={() => {
                                                                setDataAction(item);
                                                                setVisibleCardNo(true);
                                                            }}
                                                        >
                                                            <Iconify icon={'material-symbols:id-card'} />
                                                        </IconButton>
                                                    )}
                                                </TableCell>
                                                <TableCell align="left" width={200}>
                                                    {item.email}
                                                </TableCell>
                                                <TableCell align="left">{`${item.phone}`}</TableCell>
                                                <TableCell align="left" style={{ minWidth: '120px' }}>
                                                    {item.departs_nm}
                                                </TableCell>
                                                <TableCell align="left" style={{ minWidth: '150px' }}>
                                                    {item.key_mean ? item.key_mean : '---'}
                                                </TableCell>
                                                <TableCell align="left">
                                                    <Label color={(item.block === '0' && 'error') || 'primary'}>
                                                        {item.block === '1' ? t('active') : t('band')}
                                                    </Label>
                                                </TableCell>
                                                <TableCell align="right">
                                                    <ButtonGroup
                                                        variant="text"
                                                        aria-label="text button group"
                                                        style={{ display: 'flex', justifyContent: 'space-between' }}
                                                    >
                                                        {/* Click hiển thị thông tin chi tiết của User và thông tin đăng ký trên thiết bị Hikvision */}
                                                        {screenPermissions?.insert_permission === '1' && (
                                                            <IconButton
                                                                size="large"
                                                                color={'primary'}
                                                                onClick={() => handleClickDetail(item.id)}
                                                            >
                                                                <Iconify icon={'ic:outline-info'} />
                                                            </IconButton>
                                                        )}
                                                        {screenPermissions?.update_permission === '1' && (
                                                            <IconButton
                                                                size="large"
                                                                color={'warning'}
                                                                onClick={() => {
                                                                    setDataAction(item);
                                                                    isEdit.current = true;
                                                                    setVisible(true);
                                                                }}
                                                            >
                                                                <Iconify icon={'eva:edit-fill'} />
                                                            </IconButton>
                                                        )}
                                                        {screenPermissions?.block_permission === '1' && (
                                                            <IconButton
                                                                size="large"
                                                                color={(item.block === '0' && 'error') || 'primary'}
                                                                onClick={() => {
                                                                    setDataAction(item);
                                                                    setVisibleLock(true);
                                                                }}
                                                            >
                                                                <Iconify
                                                                    icon={
                                                                        item.block !== '1'
                                                                            ? 'material-symbols:lock'
                                                                            : 'material-symbols:lock-open'
                                                                    }
                                                                />
                                                            </IconButton>
                                                        )}
                                                    </ButtonGroup>
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })}
                            </TableBody>
                        </Table>

                        {tableData.length === 0 && <EmtyData />}
                    </TableContainer>
                    <Box display={'flex'} justifyContent={'space-between'} padding={2}>
                        <Stack>
                            <span>
                                {t('total_row')}: {tableData.length}/{total}
                            </span>
                        </Stack>
                        <Button
                            variant="contained"
                            endIcon={<Iconify icon="material-symbols:skip-next-rounded" />}
                            onClick={getDataNext}
                            disabled={tableData.length < total ? false : true}
                        >
                            {t('next')}
                        </Button>
                    </Box>
                    {/* </Scrollbar> */}
                </Card>
            </Container>
            {screenPermissions?.insert_permission === '1' && (
                <AddButton
                    onClick={() => {
                        isEdit.current = false;
                        setVisible(true);
                        setDataAction({});
                    }}
                />
            )}
            {/* Xuất excel */}
            <TableContainer sx={{ padding: 1, width: '100%' }} style={{ display: 'none' }}>
                <Table ref={tableRef} sx={{ paddingLeft: 2, width: '100%' }}>
                    <TableHead>
                        <TableRow>
                            {TABLE_HEAD.map((item, index) => {
                                return <TableCell key={index}>{item.label}</TableCell>;
                            })}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {tableDataExcel.length > 0 &&
                            tableDataExcel
                                .sort((a, b) => b.id - a.id)
                                .map((item, index) => {
                                    return (
                                        <TableRow hover key={index} tabIndex={-1} role="checkbox">
                                            <TableCell component="th" scope="row">
                                                <Typography variant="subtitle2" noWrap>
                                                    {index + 1}. {item.user_nm}
                                                </Typography>
                                            </TableCell>
                                            <TableCell align="left" width={200} style={{ minWidth: '150px' }}>
                                                {item.accounts}
                                            </TableCell>
                                            <TableCell align="left" width={200}>
                                                {item.code_rfid}
                                            </TableCell>
                                            <TableCell align="left">
                                                {item.face_img_nm ? (
                                                    <img
                                                        src={`${glb_sv.urlGetFaceImage(item.face_img_nm)}`}
                                                        width={30}
                                                        height={25}
                                                    />
                                                ) : (
                                                    ''
                                                )}
                                            </TableCell>
                                            <TableCell align="left">
                                                {item.card_no ? (
                                                    <div
                                                        onClick={() => {
                                                            setDataAction(item);
                                                            setVisibleCardNo(true);
                                                        }}
                                                    >
                                                        {item.card_no}
                                                    </div>
                                                ) : (
                                                    ''
                                                )}
                                            </TableCell>
                                            <TableCell align="left" width={200}>
                                                {item.email}
                                            </TableCell>
                                            <TableCell align="left">{`${item.phone}`}</TableCell>
                                            <TableCell align="left" style={{ minWidth: '120px' }}>
                                                {item.departs_nm}
                                            </TableCell>
                                            <TableCell align="left" style={{ minWidth: '150px' }}>
                                                {item.key_mean ? item.key_mean : '---'}
                                            </TableCell>
                                            <TableCell align="left">
                                                <Label color={(item.block === '0' && 'error') || 'primary'}>
                                                    {item.block === '1' ? t('active') : t('band')}
                                                </Label>
                                            </TableCell>
                                        </TableRow>
                                    );
                                })}
                    </TableBody>
                </Table>
            </TableContainer>
        </>
    );
}
